import { Autocomplete, Dialog, IconButton, Select, Skeleton, TextField } from '@mui/material'
import React,{useMemo, useState} from 'react'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { applyLeaveStaffAPICall } from '../../../../../../API/Staff/HRM/employeeLeaveAPI'
import { viewLeaveTypesAPI } from '../../../../../../API/Staff/HRM/Leave/staffLeaveTypeAPI'
import '../../../../../../css/Staff/HRM/Tab/empLeaveDetails.css'
import { FilePicker } from '../../../../../Single Components/filePicker'
import ErrorSnackbar from '../../../../../Single Components/SnackBars/ErrorSnackbar'
import SuccessSnackbar from '../../../../../Single Components/SnackBars/SuccessSnackbar'
import { convertDateFormat, currentTime, today } from "../../../../../../Js/Date"
import { getSingleEmployeeAPICall } from '../../../../../../API/Staff/HRM/employeeAPI'
import { viewLeaveApplicationsAPICall } from '../../../../../../API/Staff/HRM/Leave/staffLeaveApplicationAPI'
import { NavigateNextOutlined } from '@mui/icons-material'
import axios from 'axios'
import { HEADERS } from '../../../../../../API/UrlAndPaths'
export const EmpLeaveDetails = () => {
  const currentEmpID = localStorage.getItem("EMP_ID");
  const userRole = useSelector((state) => state.userRoleSlice.value);
  const dateAndTime=`${today} ${currentTime}`;
  const [applyLeaveDialog,setApplyLeaveDialog]=useState(false)
  const[isModify,setIsModify]=useState(false)
  const [leaveApplicationView,setLeaveApplicationView]=useState(false)
  const [showAlertLimit,setShowAlertLimit]=useState(false)
  const [showAlertBalance,setShowAlertBalance]=useState(false)
  const [balanceErrorMsg,setBalanceErrorMsg]=useState('')
  const[showAlertLeaveType,setShowAlertLeaveType]=useState(false)
  const[showAlertDate,setShowAlertDate]=useState(false)
  const[filteredLeaveList,setFilteredLeaveList]=useState([])
  const[showLeaveSummary,setShowLeaveSummary]=useState(false)
  const[showLeaveSummaryH4,setShowLeaveSummaryH4]=useState(true)

  const [searchKeyword,setSearchKeyword]=useState("")
  const [filteredSearchList,setFilteredSearchList]=useState(filteredLeaveList)
  const [leaveSingleNote,setLeaveSingleNote]=useState("")
  const [leaveSingleStatus,setLeaveSingleStatus]=useState("")
  const [leaveSingleId,setLeaveSingleId]=useState("")
  //Loading State
  const [isLoading, setIsLoading] = useState(false);
  const leaveTypeList=useSelector((state)=>
        state.allLeaveTypeSlice.value
    );
  const [leaveTypeListFallback, setLeaveTypeListFallback] = useState([])
  const viewLeaveApplications=useSelector((state)=>
    state.allLeaveApplicationSlice.value
    )
  const singleEmpData = useSelector((state) => state.singleEmployeeSlice.value);

  // calculate date diff states
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [diffDays, setDiffDays] = useState(0);

 // snackbar states
  const [successSnackbar,setSuccessSnackbar]=useState(false)
  const [errorSnackbar,setErrorSnackbar]=useState(false)
  const [snackMsg,setSnackMsg]=useState('Error!!')

  const [addDocImg, setAddDocImg] = useState(null);
  const applyLeaveBodyinitial={
        leaveType:null,
        startDate:today,
        endDate:"",
        reason:"",
        document:"",
        appliedDate:dateAndTime,
        branchId:singleEmpData?.branchId,
        employeeId:singleEmpData?.emp_id
  }
  const [applyLeaveBody,setApplyLeaveBody]=useState(applyLeaveBodyinitial)
 

  const getLeaveTypeValue=(e,newValue)=>{
      setApplyLeaveBody({...applyLeaveBody,leaveType:newValue})
      setShowAlertLeaveType(false)
      if(newValue===null){
        setShowAlertLeaveType(true)
      }
    }

  // Sanitize leave type options for Autocomplete
  const leaveOptions = useMemo(() => {
    const src = (Array.isArray(leaveTypeList) && leaveTypeList.length>0) ? leaveTypeList : leaveTypeListFallback
    const list = Array.isArray(src) ? src : (Array.isArray(src?.data) ? src.data : [])
    return list
      .filter((o) => o && (o.leaveType || o.name || o.code))
      .map((o) => ({ 
        ...o, 
        __label: [o.code, (o.leaveType || o.name || o.code)].filter(Boolean).join(' - ')
      }))
  }, [leaveTypeList, leaveTypeListFallback])
  

  const filePickerChange=(e)=>{
    setAddDocImg(e.target.files[0]);
    setApplyLeaveBody({
      ...applyLeaveBody,document:e.target.files[0]
    })
  }
  const clearStates=()=>{
    setApplyLeaveBody(applyLeaveBodyinitial)
    setDiffDays(0)
    setApplyLeaveDialog(false)
    setAddDocImg(null)
    setShowAlertLeaveType(false)
    setShowAlertDate(false)
  }
  const updateListener=()=>{
    setIsModify(!isModify)
  }

  const closeSuccessSnackbar=()=>{
    setSuccessSnackbar(false)
  }
  const closeErrorSnackbar=()=>{
    setErrorSnackbar(false)
  }


  const submitApplyNewleave=()=>{

    const hasDoc = !!addDocImg
    // Format appliedDate to match Payroll format (YYYY-MM-DD only, no time)
    const appliedDateFormatted = new Date().toISOString().split('T')[0]
    
    // Build API payload (FormData if file present)
    let payload
    if(hasDoc){
      payload = new FormData()
      payload.append('emp_id', currentEmpID)
      payload.append('leaveType', applyLeaveBody.leaveType?._id || '')
      payload.append('leaveFromeDate', applyLeaveBody.startDate)
      payload.append('leaveToDate', applyLeaveBody.endDate)
      payload.append('reason', applyLeaveBody.reason || '')
      payload.append('branchId', applyLeaveBody.branchId)
      payload.append('appliedDate', appliedDateFormatted)
      payload.append('emp', addDocImg)
    }else{
      payload = {
        emp_id: currentEmpID,
        leaveType: applyLeaveBody.leaveType?._id,
        leaveFromeDate: applyLeaveBody.startDate,
        leaveToDate: applyLeaveBody.endDate,
        reason: applyLeaveBody.reason,
        branchId: applyLeaveBody.branchId,
        appliedDate: appliedDateFormatted
      }
    }
    
    console.log('🔍 HRM Leave Submit Payload:', {
      leaveType: applyLeaveBody.leaveType?._id,
      emp_id: currentEmpID,
      branchId: applyLeaveBody.branchId,
      dates: `${applyLeaveBody.startDate} to ${applyLeaveBody.endDate}`,
      hasDocument: hasDoc
    })

    if(!applyLeaveBody.leaveType?._id){
      setShowAlertLeaveType(true)
    }
    else if((applyLeaveBody.endDate||"")===""){
      setShowAlertDate(true)
    }
    else if(showAlertLimit!==true){

      applyLeaveStaffAPICall(
          payload,
          () => {
            // Success callback
            updateListener();
            console.log('✅ Leave application submitted successfully from HRM');
            setShowAlertBalance(false);
            // Close dialog which will trigger list refresh via useEffect
            setTimeout(() => {
              clearStates();
            }, 2500); // Increased delay to 2.5s to ensure backend has committed the data
          },
          setSuccessSnackbar,
          (isError) => {
            // Error callback
            setErrorSnackbar(isError);
            setShowAlertBalance(true);
          },
          (msg) => {
            // Message callback
            setSnackMsg(msg);
            setBalanceErrorMsg(msg);
          }
          )
        }
  }
  const leaveReasonSingleView=(reason,status,id)=>()=>{
    setLeaveApplicationView(true)
    setLeaveSingleNote(reason)
    setLeaveSingleStatus(status)
    setLeaveSingleId(id)
  }
  

  const searchLeaveFilter=(chars,leaveList)=>{
    let searchFilter=[]
    let filteredArray=[]
    if(chars!==""){
      searchFilter=leaveList?.filter((obj)=>
                      obj?.leaveType?.toLowerCase()?.includes(chars?.toLowerCase())
      )
      filteredArray=searchFilter
    }
    else{
      filteredArray=leaveList
    }
    return filteredArray
  }
  const buttonDemoClick=()=>{
    // Match Payroll behavior: request by branch only; filter by emp on client
    console.log('📡 HRM fetching leave applications for branch:', singleEmpData?.branchId);
    viewLeaveApplicationsAPICall(
      { branchId: singleEmpData?.branchId },
      setIsLoading
      );
      setShowLeaveSummary(true)
      setShowLeaveSummaryH4(false)
    }

  useEffect(() => {
    getSingleEmployeeAPICall({ id: currentEmpID });
  }, []);
  
  // Blur trigger button and focus first field to avoid aria-hidden focus warning
  useEffect(()=>{
    if(applyLeaveDialog){
      try{ document.activeElement && typeof document.activeElement.blur === 'function' && document.activeElement.blur(); }catch{}
    }
  },[applyLeaveDialog])

  // Map leaveType _id -> label for display
  const leaveTypeMap = useMemo(() => {
    const map = {}
    try{
      const list = Array.isArray(leaveOptions) ? leaveOptions : []
      list.forEach(o => {
        const id = o?._id || o?.id
        const label = o?.__label || o?.leaveType || o?.name || o?.code
        if(id && label) map[String(id)] = String(label)
      })
    }catch{}
    return map
  }, [leaveOptions])
  useEffect(()=>{
    let timeDiff =Math.abs(endDate.getTime()-startDate.getTime());
    setDiffDays(Math.ceil(timeDiff /(1000*3600*24)))
  },[endDate,startDate])
   
  useEffect(()=>{
      if(applyLeaveBody.leaveType!==null && diffDays>applyLeaveBody.leaveType.numberOfDays){
        setShowAlertLimit(true)
      }
      else(
        setShowAlertLimit(false)
      )
  },[diffDays])
  // listing all leaveType API call  
  useEffect(()=>{
    viewLeaveTypesAPI();
    },[])

  // Fallback loader if Redux list is empty or undefined
  useEffect(()=>{
    const needFallback = !Array.isArray(leaveTypeList) || leaveTypeList.length===0
    if(needFallback){
      axios.get('employee/viewLeaveType', HEADERS)
        .then(res=>{
          const list = res?.data?.data || res?.data || []
          setLeaveTypeListFallback(list)
        })
        .catch(()=>setLeaveTypeListFallback([]))
    }
  },[leaveTypeList])

  // Also load fallback when dialog is opened (ensures list available in modal)
  useEffect(()=>{
    if(applyLeaveDialog){
      const needFallback = !Array.isArray(leaveTypeList) || leaveTypeList.length===0
      if(needFallback){
        axios.get('employee/viewLeaveType', HEADERS)
          .then(res=>{
            const list = res?.data?.data || res?.data || []
            setLeaveTypeListFallback(list)
          })
          .catch(()=>setLeaveTypeListFallback([]))
      }
    }
  },[applyLeaveDialog])

  useEffect(()=>{
    setFilteredLeaveList([])
    // Prefer server-side empId filter; fallback to client-side
    const dataArr = Array.isArray(viewLeaveApplications) ? viewLeaveApplications : []
    const expectedEmpId = String(currentEmpID)
    // singleEmpData.emp_id might be numeric (1) or already formatted (EMP1)
    const rawEmpId = singleEmpData?.emp_id
    const expectedEmpCode = rawEmpId != null 
      ? (String(rawEmpId).startsWith('EMP') ? String(rawEmpId) : `EMP${rawEmpId}`)
      : null
    console.log('🔍 Filtering leave list:', {
      total: dataArr.length,
      expectedEmpId,
      expectedEmpCode,
      sampleRecord: dataArr[0]
    });
    let filtereData = dataArr.filter((obj)=> {
      const byMongoId = String(obj?.empId?._id || obj?.empId) === expectedEmpId
      const byEmployeeIdCode = expectedEmpCode ? String(obj?.employeeId) === String(expectedEmpCode) : false
      const match = byMongoId || byEmployeeIdCode
      if(!match && dataArr.length > 0) {
        console.log('   Record not matched:', {
          recordEmpId: obj?.empId,
          recordEmployeeId: obj?.employeeId,
          expectedEmpId,
          expectedEmpCode
        });
      }
      return match
    })
    console.log('   Filtered to:', filtereData.length, 'records for this employee');
    setFilteredLeaveList(filtereData)
  },[viewLeaveApplications, currentEmpID, singleEmpData?.emp_id])

  useEffect(()=>{
    if(filteredLeaveList!==undefined){
      setFilteredSearchList(filteredLeaveList)
      let filteredArray=searchLeaveFilter(searchKeyword,filteredLeaveList)
      setFilteredSearchList(filteredArray)
    }
    else{
      setFilteredSearchList([])
    }
  },[searchKeyword,filteredLeaveList])

  // compute Used/Allotted badges from applications and leave types
  const leaveUsageByType = useMemo(()=>{
    const map = {}
    const arr = Array.isArray(filteredLeaveList) ? filteredLeaveList : []
    arr.forEach(l => {
      const key = typeof l.leaveType === 'object' ? (l.leaveType?.leaveType || l.leaveType?.name || l.leaveType?._id) : l.leaveType
      const days = Number(l?.days || 0)
      if(!key) return
      map[key] = (map[key] || 0) + days
    })
    return map
  },[filteredLeaveList])

  const findLeaveTypeByName = (name)=>{
    const list = Array.isArray(leaveTypeList) ? leaveTypeList : []
    return list.find(lt => [lt?.leaveType, lt?.name].filter(Boolean).some(v => String(v).toLowerCase().includes(String(name).toLowerCase())))
  }
  const getBadge = (name, fallbackTotal=365)=>{
    const lt = findLeaveTypeByName(name) || {}
    const label = lt?.leaveType || lt?.name || name
    const allotted = Number(lt?.numberOfDays ?? fallbackTotal)
    const used = Number(leaveUsageByType[label] || 0)
    return { used, allotted }
  }
  const paidBadge = getBadge('Paid')
  const sickBadge = getBadge('Sick', 10)
  const unpaidBadge = getBadge('Unpaid')

  useEffect(()=>{
    if(!applyLeaveDialog){
      // Load when dialog is closed (including after successful submit)
      console.log('🔄 HRM Leave dialog closed, refreshing list...');
      buttonDemoClick();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[applyLeaveDialog])

  return (
    <div className='dashboard-employee-leave-details-container'>
      <div className='dashboard-employee-leave-details-top-container'>
         <div className='dashboard-employee-leave-details-top-btn-grp-container'>
          <button className='btn btn-primary' style={{backgroundColor:"#149114",cursor:"context-menu"}}>Paid Leave &nbsp; {paidBadge.used}&nbsp;/&nbsp;{paidBadge.allotted}</button>
          <button className='btn btn-primary' style={{backgroundColor:"#ff0000",cursor:"context-menu"}}>Sick Leave &nbsp; {sickBadge.used}&nbsp;/&nbsp;{sickBadge.allotted}</button>
          <button className='btn btn-primary' style={{backgroundColor:"#ff5700",cursor:"context-menu"}}>Unpaid Leave &nbsp; {unpaidBadge.used}&nbsp;/&nbsp;{unpaidBadge.allotted}</button>
         </div>

         {/* {
           userRole==="user"? */}
           <button onClick={()=>setApplyLeaveDialog(true)} className='btn btn-primary btn-font-size-less'>Apply For Leave</button>
         {/* :""} */}
      </div>
      <div className='dashboard-employee-leave-details-top-container'>
         <div className='dashboard-employee-leave-details-top-btn-grp-container'>
           {showLeaveSummaryH4?<button 
            className="btn btn-primary show-leave-btn"  
            onClick={buttonDemoClick}>
            Leave Summary<NavigateNextOutlined/>
            </button>
              :<h4>Leave Summary</h4>}
         </div>
         {showLeaveSummaryH4?
           "":
         <div className="view-order-search-container view-order-admin-search-container" style={{width:"25%"}}>
              <input
              placeholder="Search LeaveType"
              value={searchKeyword}
              onChange={(e)=>setSearchKeyword(e.target.value)}
              />
              <IconButton>
              <i class="bi bi-search search-icon-order"></i>
              </IconButton>
          </div>
          }
      
      </div>
      {
        showLeaveSummary?
        <div className='global-table-container dashboard-leave-details-table-container'>
         <table className='global-table'>
          <thead>
          <tr>
            <th>No</th>
            <th>Leave Type</th>
            <th>Date From</th>
            <th>Date To</th>
            <th>Days</th>
            <th>Applied On</th>
            <th>Status</th>
            <th>View</th>
            <th>Delete</th>
           </tr>
          </thead>
          {isLoading ? (
          <tbody>
            <tr>
              <td colSpan={9}>
                {/* <Loader /> */}
                <Skeleton
                  variant="rectangular"
                  animation="wave"
                  width={"100%"}
                  height={40}
                />
              </td>
            </tr>
            <tr>
              <td colSpan={9}>
                {/* <Loader /> */}
                <Skeleton
                  variant="rectangular"
                  animation="wave"
                  width={"100%"}
                  height={40}
                />
              </td>
            </tr>
            <tr>
              <td colSpan={9}>
                {/* <Loader /> */}
                <Skeleton
                  variant="rectangular"
                  animation="wave"
                  width={"100%"}
                  height={40}
                />
              </td>
            </tr>
            <tr>
              <td colSpan={9}>
                {/* <Loader /> */}
                <Skeleton
                  variant="rectangular"
                  animation="wave"
                  width={"100%"}
                  height={40}
                />
              </td>
            </tr>
            <tr>
              <td colSpan={9}>
                {/* <Loader /> */}
                <Skeleton
                  variant="rectangular"
                  animation="wave"
                  width={"100%"}
                  height={40}
                />
              </td>
            </tr>
          </tbody>
              ) : (
          <tbody>
             {
               filteredSearchList?.length!==0?
               filteredSearchList
               ?.map((r,i)=>
              <tr key={i}>
              <td>{i+1}</td>
             <td>{
               // r.leaveType may be an id, object, or already a string
               leaveTypeMap[String(r?.leaveType)] || r?.leaveType?.leaveType || r?.leaveType?.name || r?.leaveType?.code || r?.leaveType || ''
             }</td>
              <td>{convertDateFormat(r?.DateFrom)}</td>
              <td>{convertDateFormat(r?.DateTo)}</td>
              <td>{r?.days}</td>
              <td>{convertDateFormat(r?.appliedDate)}</td>
              <td>
                    {r?.status==="APPROVED"?(
                      <p className="status-text-stock-out-pending">Accepted</p>)
                      :r?.status==="REJECTED"?(
                        <p className="status-text-stock-out-reject">Rejected</p>)
                        :(
                          <p className="status-text-stock-out">Pending</p>)
                    }
              </td>
              <td>
              <IconButton onClick={leaveReasonSingleView(r?.reason,r?.status,r?._id)}>
               <i class="bi bi-eye visibility-icon"></i>
              </IconButton>
              </td>
              <td>
              <IconButton>
              <i class="bi bi-trash3 delete-icon"></i>
              </IconButton>
              </td>
            </tr>
              ):(
                <tr>
                  <td colSpan={10}>No Records</td>
                </tr>
              )

             }
            
          </tbody>
              )}
         </table>
      </div>
            :""}


      <Dialog open={applyLeaveDialog} maxWidth="lg" onKeyDown={(e)=>e.key === "Escape" && setApplyLeaveDialog(false)}>
        <div className='dashboard-employee-leave-details-dialog-container'>
          <div className='dashboard-employee-leave-details-dialog-top-container'>
            <h3>Apply For Leave</h3>
            <p>Selected Days&nbsp;:&nbsp;<span>{diffDays}</span></p>
            {showAlertLimit?
            <p className="alert-leave-limit">
              Allotted Days For this Leave Type is {applyLeaveBody.leaveType!==null &&applyLeaveBody.leaveType.numberOfDays} days
              </p>:""
            }
            {showAlertBalance?
            <p className="alert-leave-limit" style={{backgroundColor:"#ffebee",color:"#c62828"}}>
              {balanceErrorMsg}
              </p>:""
            }
          </div>
          <hr  className='global-hr'/>
           <div>
            <div className='global-single-input dashboard-emp-apply-leave-input auto-complete'>
              <p>Select Leave Type</p>
              <Autocomplete
                sx={{width:"100%"}}
                options={leaveOptions}
                value={applyLeaveBody.leaveType}
                isOptionEqualToValue={(opt, val)=> String(opt?._id || opt.__label) === String(val?._id || val.__label)}
                getOptionLabel={(option)=> (option && (option.__label || option.leaveType || option.name || option.code)) || ""}
                renderInput={(params) => <TextField {...params} autoFocus />}
                onChange={getLeaveTypeValue}
              />
              {showAlertLeaveType?
                <p className="validation-alert-red">
                  Select a leave type!!</p>:""
                }
            </div>
            <div className='global-single-input dashboard-emp-apply-leave-input'>
              <p>Leave Date From</p>
              <input type="date"
              value={applyLeaveBody.startDate}
              onChange={(e)=>{setApplyLeaveBody({...applyLeaveBody,startDate:e.target.value});
                              setStartDate(new Date(e.target.value))
            }}
              />
            </div>
            <div className='global-single-input dashboard-emp-apply-leave-input'>
              <p>Leave Date To</p>
              <input type="date"
              value={applyLeaveBody.endDate}
              onChange={(e)=>{setApplyLeaveBody({...applyLeaveBody,endDate:e.target.value});
                              setEndDate(new Date(e.target.value));
                              setShowAlertDate(false)
                            }}
              />
              {showAlertDate?
                <p className="validation-alert-red">
                  Fill this field!!</p>:""
                }
            </div>
            <div className='global-single-input dashboard-emp-apply-leave-input'>
              <p>Reason</p>
              <textarea  rows={4}
              onChange={(e)=>{setApplyLeaveBody({...applyLeaveBody,reason:e.target.value})}}
              />
            </div>
            <div className='global-single-input dashboard-emp-apply-leave-input'>
              <p>Document Upload</p>
              <FilePicker
                id="staffLeaveApplyDoc"
                uploadImageUrl={addDocImg}
                setImage={setAddDocImg}
                onChange={filePickerChange}
              />
            </div>


           </div>
           <div className='dashboard-employee-leave-details-dialog-button-container'>
            <button  onClick={clearStates} className='btn btn-secondary-outlined'>Cancel</button>
            
            <button onClick={submitApplyNewleave} className='btn btn-primary'>Submit</button>
           </div>
        </div>
      </Dialog>
 
    {/* leaveApplicationView */}
      <Dialog open={leaveApplicationView} maxWidth="lg" onClose={()=>setLeaveApplicationView(false)}>
          <div className="leave-application-view-container">
              <div className="leave-application-view-container-top">
                  <h3>Leave Application</h3>
              </div>
              <div className="leave-application-view-container-body">
                  <p>{leaveSingleNote}
                      </p>
              </div>
              <div className="leave-application-view-container-button">
                            {leaveSingleStatus==="APPROVED"?(
                              <p className="status-text-stock-out-pending">Accepted</p>)
                            :leaveSingleStatus==="REJECTED"?(
                              <p className="status-text-stock-out-reject">Rejected</p>)
                            :(
                              <p className="status-text-stock-out">Pending</p>)
                            }
              </div>
          </div>
      </Dialog>
      <SuccessSnackbar
      open={successSnackbar}
      handleClose={closeSuccessSnackbar}
      message={snackMsg}
      />
      <ErrorSnackbar
      open={errorSnackbar}
      handleClose={closeErrorSnackbar}
      message={snackMsg}
      />
    </div>
  )
}
